module.exports = __webpack_public_path__ + "static/02-36ee5ab5ba997623d3efe93413f8a914.jpg";